export type PaginationType = {
	current_page: number;
	next_page: number | null;
	prev_page: number | null;
	total_pages: number;
	total_count: number;
	limit_value: number;
};

export type UserType = {
	first_login: boolean;
	onboarding_passed: boolean;
	phone: string;
	pm_id: number;
	pm_points: number;
	public_offer_accepted: boolean;
	shop_enabled: boolean;
	skin_place_payform_url: string;
	steam_id: number | null;
	steam_private_inventory: boolean;
	steam_private_match_data: boolean;
	steam_trade_url: string;
	twitch_id: number | null;
	twitch_nickname: string;
	twitch_url: string | null;
};

export enum ITEM_TYPE {
	REA_BONUS = 'rea_bonus',
	SHP_GIVEAWAY = 'shp_giveaway',
	MERCH_PRIZE = 'merch_prize',
	LOTTERY = 'lottery'
}

export enum RARITY {
	COMMON = 'common',
	RARE = 'rare',
	EPIC = 'epic',
	LEGENDARY = 'legendary'
}

export enum GAME {
	DOTA2 = 'dota2',
	CSGO = 'csgo'
}

export enum REA_BONUS_TYPE {
	FREE_BET = 'free_bet',
	FREE_SPIN = 'free_spin'
}

export enum SORT_ORDER {
	ASC = 'asc',
	DESC = 'desc'
}

export type ShopItem = {
	id: string;
	item_type: ITEM_TYPE;
	name: string;
	description: string;
	price: number;
	limit_24h: number;
	limit_per_user: number;
	initial_amount: number;
	amount_left: number;
	game: GAME;
	rarity: RARITY;
	rea_bonus_type: REA_BONUS_TYPE;
	image: string;
	items_in_stock: number;
	infinite_stock: boolean;
	lottery_id: string;
	new_item: boolean;
	hot_item: boolean;
};

export type Category = {
	id: string;
	name: string;
	tag: string;
	position: number;
	image_url: string;
	new_item: boolean;
	hot_item: boolean;
};

export type ShopItemsMeta = {
	categories: Category[];
	category_tags?: Record<string, string>;
	enabled_pagination: boolean;
};

export type ShopItemsResponse = {
	status: string;
	data: ShopItem[];
	meta: ShopItemsMeta;
	pagination: PaginationType;
};

export type ShopItemsQueryParams = {
	category_ids?: string[];
	lang?: string;
	game?: GAME[];
	rarity?: RARITY[];
	rea_bonus_type?: REA_BONUS_TYPE[];
	type?: ITEM_TYPE[];
	order?: SORT_ORDER;
	page?: number;
	per_page?: number;
};

export type TransactionType = {
	amount: number;
	created_at: string;
	id: string;
	shop_item: ShopItem;
	status: string;
	type: string;
};

export type TabsType = {
	id: string;
	name: string;
};

export type ShopPurchaseResponse = {
	status: 'success';
	code: 200;
};

export type ShopPurchaseErrorResponse = {
	status: 'error';
	errors: ShopErrorType[];
};

export type ShopMutationError = {
	data: ShopPurchaseErrorResponse;
};

export type LotteryPurchaseRequest = {
	shop_item: {
		count: number;
	};
};

// Shop error types
export type ShopErrorType =
	| 'user_has_shop_disabled'
	| 'user_has_no_steam_trade_url'
	| 'shop_item_not_published'
	| 'user_has_not_enough_pm_points'
	| 'user_reached_limit_24h'
	| 'user_reached_limit_per_user'
	| 'items_in_stock_reached_limit'
	| 'rea_bonus_callback_error'
	| 'lottery_is_expired'
	| 'shop_item_is_not_lottery'
	| 'bad_item_params_error';
